module.exports = __webpack_public_path__ + "catalog/items/outdoor/outdoorchairs/outdoorchairs.svg";